import type { ClientCapability } from "./portal-routes";
import { consolePath, orgPath, parseConsolePath } from "./portal-routes";

export type PaletteClientScope = { kind: "org"; clientId: string | null } | { kind: "console"; clientId: string };

export function resolvePaletteClientScope(
  superAdmin: boolean,
  pathname: string,
  membershipClientId: string | null,
): PaletteClientScope | null {
  if (!superAdmin) {
    return { kind: "org", clientId: membershipClientId };
  }

  const consoleMatch = parseConsolePath(pathname);
  return consoleMatch ? { kind: "console", clientId: consoleMatch.clientId } : null;
}

export function paletteClientPath(scope: PaletteClientScope, capability: ClientCapability): string {
  return scope.kind === "console" ? consolePath(scope.clientId, capability) : orgPath(capability);
}
